import { baseApi } from "./baseApi";
import { SelectListDto } from "../../models";

export const courseApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getCourseSelectList: builder.query<SelectListDto[], void>({
      query: () => ({
        url: `/api/course/select-list/all`,
      }),
      providesTags: ["Course"],
    }),
    getCourseAndGradesSelectList: builder.query<SelectListDto[], void>({
      query: () => ({
        url: `/api/course/select-list/courses-grades`,
      }),
      providesTags: ["Course"],
    }),
  }),
});

export const {
  useGetCourseSelectListQuery,
  useGetCourseAndGradesSelectListQuery,
} = courseApi;
